import { connect } from "react-redux";

import Component from "./Component";
import { getIsOrganizer, getIsTrainer } from "domain/Game/selectors";
import {
    getIsOrganizer as getIsOrganizerRegularGame,
    getIsTrainer as getIsTrainerRegularGame,
} from "domain/RegularGames/selectors";
import { getUserId } from "domain/User/selectors";

const mapStateToProps = (state, { gameId, isRegular }) => {
    const userId = getUserId(state);

    return {
        isOrganizer: isRegular
            ? getIsOrganizerRegularGame(state, gameId, userId)
            : getIsOrganizer(state, gameId, userId),
        isTrainer: isRegular
            ? getIsTrainerRegularGame(state, gameId, userId)
            : getIsTrainer(state, gameId, userId),
    };
};

export default connect(mapStateToProps)(Component);
